<template>
  <div class="dashboard-container">
    <div class="app-container">题库添加</div>
  </div>
</template>

<script>
export default {
  name: 'QuestionsNew',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
